import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseNode } from '@app/utilities/foblex-flow/base-node/base-node';
import { FlowNode, NodeManager } from '@app/utilities/foblex-flow/node-manager';
import { Device, Node } from '@models';
import { DialogService } from '@app/old-ui/dialog/dialog.service';
import { D80ReductionRatio } from '../../reduction-ratio';

export class DeviceNode extends BaseNode {
    public device: Device;

    constructor(device: Device, node?: FlowNode) {
        if (node) {
            const dimension = node.dimension ?? { width: 5, height: 3 };
            super(node.id, dimension.height, dimension.width,device.id,'device');
            this.position = node.position;
        } else {
            super(0, 3, 5,device.id, 'device');
            this.position = { x: 50, y: 50 };
        }
        this.type = 'device';
        this.device = device;
        this.inputId = `input-${this.device.uuid}`;
        this.outputId = `output-${this.device.uuid}`;
    }

    public toNode(): Node {

        const node = new Node();

        node.id = this.id;
        node.type = this.type;
        node.resourceId = this.device.id;
        node.siteId = this.device.siteId;
        node.position = JSON.stringify(this.position);
        node.dimension = JSON.stringify(this.dimension);
        node.outputId = this.outputId;
        node.inputId = this.inputId;

        return node;
    }

    public static isDeviceNode(node: FlowNode): node is DeviceNode {
        return node.type === 'device';
    }
}

@Component({
    selector: 'device-node',
    templateUrl: './device-node.component.html',
    styleUrls: ['./device-node.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceNodeComponent {
    @Input() node: DeviceNode;
    @Input() hasUpstreamConnection = false;
    @Input() reductionRatioLoading = false;
    @Input() reductionRatio: D80ReductionRatio | null;

    constructor(
        private readonly nodeManager: NodeManager,
        private readonly dialog: DialogService,
    ) {}

    public openChartNode(node: DeviceNode) {
        this.nodeManager.addTemporaryPSDChartNode(node);
    }

    public openReductionRatio(event: MouseEvent): void {
        event.stopPropagation();
        if (this.reductionRatio) {
            this.dialog.openReductionRatioDetails(this.reductionRatio);
        }
    }

}
